// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"ff9570ac","727":"19f4efa2","728":"a6a6300f","766":"4521286a","886":"45641dde"}[chunkId] + ".chunk.css";
};